import BillingDashboard from "@/models/general/settings/BillingDashboard";
import moment from "moment";

export default {
    namespaced: true,

    state: () => ({
        paymentMethods: null,
        selectedMethod: null,
        paymentCards: null,
        stripeSessionData: null,
        authDetails: null
    }),

    mutations: {
      
        setPaymentMethods(state, payload) {
            state.paymentMethods = payload;
        },
        setSelectedMethod(state, payload) {
            state.selectedMethod = payload;
        },
        
        setPaymentCards(state, payload) {
            state.paymentCards = payload;
        },

        setStripeSessionData(state, payload) {
            state.stripeSessionData = payload
        },
        
        setAuthDetails(state, payload) {
            state.authDetails = payload
        },

    },

    actions: {

        
        async getPaymentMethods({ commit,getters, state }) {
            try {
                commit("setLoading", true, { root: true });
                commit("setPaymentMethods", []);
                const { data } = await BillingDashboard.getPaymentMethods();
                commit("setPaymentMethods", data.data.payment_methods);
                commit("setSelectedMethod", data.data.payment_methods.find(x => x.selected));
                commit("setLoading", false, { root: true });
                
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response?.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        
        async getStripeMethods({ commit,getters, state }) {
            try {
                commit("setLoading", true, { root: true });
                commit("setPaymentCards", null);
                const { data } = await BillingDashboard.getStripeMethods();

                commit("setPaymentCards", data.data);
                commit("setLoading", false, { root: true });
                
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response?.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        
        async doStripeAction({ commit,getters, state },{action, method}) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await BillingDashboard.doStripeAction(action, method);
                commit("setLoading", false, { root: true });
                return data
                
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.log(ex)
                commit("setErrorMessage", ex.response?.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        
        async chooseMethod({ commit,getters, state }, id) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await BillingDashboard.attachPaymentMethod( { store_payment_method_id: id } );

                // commit("setPaymentCards", data.data);
                commit("setLoading", false, { root: true });
                return data
                
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response?.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },
        
        async addStripeMethod({ commit }) {
            try {

                commit("setLoading", true, { root: true });
                commit("setErrorMessage", '', {
                    root: true
                });
                const { data } = await BillingDashboard.addStripeMethod();
                commit("setStripeSessionData", data.data)
                commit("setLoading", false, { root: true });
            } catch (ex) {
                if(ex.response?.data.code == 301){
                    commit("setPaymentMethods", ex.response.data.data.store_payment_methods);
                }
                commit("setLoading", false, { root: true });
                console.error(ex);
            }
        },
        
        async authenticatePayment({ commit }) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await BillingDashboard.authenticatePayment();

                commit("setAuthDetails", data.data || {})

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },


        
        async updatePaymentMethod({ commit,getters, state }, id) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await BillingDashboard.updatePaymentMethod( { store_payment_method_id: id } );

                commit("setLoading", false, { root: true });
                return data
                
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response?.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },
     }
};
